import { Helpers } from '../../helpers';
import { IPipelineType } from '../../interfaces/ipipeline-type';
import { Pipeline } from '../pipeline';

export class PipelineTypeBase {
  PipelineTypeId: number;
  Name: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pipelines_PipelineType?: Array<Pipeline> | null;

  constructor(item?: IPipelineType) {
    if (item) {

      this.PipelineTypeId = item.PipelineTypeId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pipelines_PipelineType = Helpers.createClassArray(Pipeline, item.Pipelines_PipelineType);
    }
  }
}